import { CommonPager, CommonSort, NestedFilter, PageInfo } from '@@partner:types:graphql'
import { ShopTagInfo } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'

export interface AllShopTagsQuery {
  allShopTags?: {
    edges: ShopTagInfo[]
    pageInfo: PageInfo
  }
}

export interface AllShopTagsVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager?: CommonPager
}

export const GQL_QUERY_ALL_SHOP_TAGS = gql`
  query allShopTags (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allShopTags(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
        edges {
          id
          name
          system_name
          icon {
            url
          }
          sort_order
          i18n {
            language_code
            name
          }
        }
        pageInfo {
          ${SHORTCUT_PAGE_INFO_FIELDS}
        }
      }
  }
`

export const useFetchAllShopTags = (
  variables: AllShopTagsVariables
) => useQuery<AllShopTagsQuery, AllShopTagsVariables>(
  GQL_QUERY_ALL_SHOP_TAGS,
  {
    variables,
    fetchPolicy: 'cache-and-network'
  })